package com.shadowings.gero.data.lessons

import com.shadowings.gero.presentation.model.Verb
import com.shadowings.gero.presentation.model.Word

// Shared by VsoSentenceUtils, AdverbialSentenceUtils and PseudoverbalSentenceUtils.
// Callers do their own `.shuffled(random)` and their own shortfall/fallback handling
// (those differ per call site - see composeApp/AGENTS.md-adjacent refactor plan);
// this only does the shuffled-list walk that dedupes by `baseWordId`, mutating the
// caller-supplied `usedBaseIds` so callers that need cross-field exclusion (e.g. a
// subject and an object never sharing a base word) can pass the same set to two calls.
fun pickDistinctIdsByBaseWord(
    shuffledCandidateIds: List<String>,
    count: Int,
    words: List<Word>,
    usedBaseIds: MutableSet<String> = mutableSetOf()
): List<String> {
    val chosen = mutableListOf<String>()
    for (id in shuffledCandidateIds) {
        if (chosen.size == count) break
        val base = words.firstOrNull { it.id == id }?.baseWordId ?: id
        if (base !in usedBaseIds) {
            chosen.add(id)
            usedBaseIds.add(base)
        }
    }
    return chosen
}

// How many of `ids` could actually be picked together without two of them
// sharing a base word (e.g. FALCO/FALCHI count as 1, not 2) - lets a caller
// reject "soggettiCount=2" against a candidate list that only has one root
// before ever calling pickDistinctIdsByBaseWord, instead of discovering the
// shortfall only after a shuffle and falling back to root-blind selection.
fun distinctBaseWordCount(ids: List<String>, words: List<Word>): Int =
    ids.map { id -> words.firstOrNull { it.id == id }?.baseWordId ?: id }.distinct().size

fun List<Verb>.hasVerbKey(key: String): Boolean = any { it.chiaveWords == key }

fun List<String>.anyResolvable(wordMap: Map<String, Word>): Boolean = any { wordMap.containsKey(it) }
